import { ContactCategory, ContactSubCategory } from 'src/Constants/ContactCategories.constants';
import { ContactKind } from 'src/Services/API/generated';

// Professions usually hired as individuals, even inside a professional category.
const PERSON_SUBCATEGORIES = new Set<string>([
  'Cleaning Lady / Cleaning Service',
  'Concierge / Home Help',
  'Gardener / Landscaper',
  'Local General Practitioner',
]);

const COMPANY_CATEGORIES = new Set<string>([
  'Professionals & Services',
  'Emergencies & Institutions',
]);

/** Person / company preset from the category, used at creation only. */
export const getPresetContactKind = (
  category?: ContactCategory,
  subcategory?: ContactSubCategory
): ContactKind => {
  if (!category || !COMPANY_CATEGORIES.has(category)) return ContactKind.Person;
  if (subcategory && PERSON_SUBCATEGORIES.has(subcategory)) return ContactKind.Person;
  return ContactKind.Company;
};

/** Categories where a person card can be turned into a company. */
export const canConvertToCompany = (category?: ContactCategory) =>
  !!category && COMPANY_CATEGORIES.has(category);
